import CopyToClipboard from "@components/ui-components/copy-to-clipboard";
import CustomTooltip from "../../ui-components/tooltip";
import Flex from "@components/ui-components/flex";
import size from "lodash/size";
import { t } from "i18next";

const LongNameFormatter = ({
    content = "",
    id = "",
    max = 0,
    className = "",
    testId = "",
    tag = null,
    copyTxt = "",
    ...otherProps
}) => {
    const Tag = tag || "div";
    const tempId = String(id)?.replaceAll(/[^A-Za-z0-9_]/g, "");
    return (
        <>
            {content ? (
                size(content) >= max ? (
                    <Flex align="start">
                        <Tag
                            {...otherProps}
                            className={className}
                            style={{ whiteSpace: "pre-line" }}
                            id={`Id-${tempId}`}
                            data-cy={testId || tempId}>
                            {`${t(content.slice(0, max - 1))}...`}
                            <small className="text-primary">{"See More"}</small>
                        </Tag>
                  
                        <CustomTooltip
                            target={`Id-${tempId}`}
                            content={<span style={{ whiteSpace: "pre-line" }}>{t(content)}</span>}/>
                  
                        {copyTxt ? (
                            <CopyToClipboard text={copyTxt} id={testId || tempId} />
                        ) : null}
                    </Flex>
                  
                ) : (
                    <Flex align="center">
                        {" "}
                        <Tag className={className} data-cy={testId || tempId}
                            {...otherProps}>
                            {t(content)}
                        </Tag>
                        {copyTxt ? (
                            <CopyToClipboard text={copyTxt} id={testId || tempId} />
                        ) : null}
                    </Flex>
                )
            ) : (
                "-"
            )}
        </>
    );
};

export default LongNameFormatter;
